<template>
    <div id="grades-container">
        <label class="label">Auction grades</label>
        <div class="field is-grouped is-grouped-multiline">
            <div class="control" v-for="(name, index) in names" :key="index">
                <label class="checkbox">
                    <input type="checkbox"
                           :checked="checkAuctionGrades(name)"
                           @click="handleAuctionGrades(name)">
                    {{ name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                names: [3, 3.5, 4, 5, 6, 7, 8, 'S', 'R', 'RA', '*', '**', '***']
            }
        },
        methods: {
            checkAuctionGrades: function (grade) {
                return this.$store.getters.getQueryAuctionGradeStatus(grade)
            },
            handleAuctionGrades: function (grade) {
                this.$store.dispatch('handleQueryGrades', grade)
            }
        }
    }
</script>

<style scoped>
    #grades-container {
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/AuctionGrades.vue